<nav #navbar class="premium-navbar">
  <div class="navbar-container">
    <!-- Left Section: Sidebar Toggle & Brand -->
<div class="navbar-left">
  <div class="navbar-minimize">
    <!-- Dynamic Arrow Button (changes direction based on state) -->
    <button 
    class="nav-arrow-btn" 
    [class.arrow-back]="isDocExpanded"
    [class.arrow-forward]="!isDocExpanded"
    (click)="minimizeSidebar()">
    <span class="arrow-wrapper">
      <span class="arrow-shaft"></span>
      <span class="arrow-tip"></span>
    </span>
  </button>
    
    <!-- Sidebar Toggle -->
    
  </div>
  <a class="navbar-brand" href="{{getPath()}}">{{getTitle()}}</a>
</div>
    <!-- <div class="navbar-left">
      <div class="navbar-minimize">
        <button class="sidebar-toggle-btn" (click)="minimizeSidebar()" aria-label="Minimize sidebar">
          <i class="material-icons visible-on-sidebar-regular">more_vert</i>
          <i class="material-icons visible-on-sidebar-mini">view_list</i>
        </button>
      </div>
      <a class="navbar-brand" href="{{getPath()}}">{{getTitle()}}</a>
    </div> -->
    <button class="navbar-toggler" type="button" (click)="sidebarToggleNew()" aria-label="Toggle navigation">
      <i class="material-icons">
        {{ isSidebarOpen ? 'chevron_left' : 'chevron_right' }}
      </i>
    </button>
    <!-- Mobile Menu Toggle -->
    <!-- <button class="navbar-toggler" type="button" (click)="sidebarToggle()" aria-label="Toggle navigation">
      <span class="hamburger-icon">
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </span>
    </button> -->

    <!-- Right Section: Search & Actions -->
    <div class="navbar-right">
      <!-- Search Bar -->
      <div class="search-container">
        <div class="search-wrapper">
          <i class="material-icons search-icon">search</i>
          <input 
            type="text" 
            class="search-input" 
            placeholder="Search here..." 
            aria-label="Search">
        </div>
      </div>

      <!-- Actions -->
      <ul class="navbar-actions">
      <!-- Dashboard Link -->
     
    
      <!-- Account Link -->
      <div class="date-time-compact">
        <!-- 28 Aug.2020 ; 20:51:23 Hrs -->
        <i class="fa fa-clock"></i>
        {{ currentDate | date:'dd.MM.yyyy HH:mm:ss' }} Hrs
      </div>
      <div class="user-menu-container">
        <button class="user-menu-toggle">
          <i class="material-icons">account_circle</i>
          <span class="username">{{username}}</span>
          <i class="material-icons">expand_more</i>
        </button>
  
        <!-- User Dropdown -->
      
      </div>

      <button class="logout-btn" title="Logout" (click)="logout()">
        <i class="material-icons">exit_to_app</i>
    </button>
      <!-- <button class="logout-footer-btn" >
        <i class="material-icons">exit_to_app</i>
        <span>Logout</span>
      </button> -->
      <!-- <li class="action-item">
        <a href="#" class="action-link account-link" title="Account">
          <i class="material-icons">person</i>
          <span class="action-label">{{username}}</span>
        </a>
      </li>
     -->
      <!-- Divider -->
      <li class="action-item divider"></li>
    
      <!-- Notifications Link -->
      <!-- <li class="action-item">
        <a href="#" class="action-link notification-link" title="Notifications">
          <i class="material-icons">notifications</i>
          <span class="notification-badge">3</span>
        </a>
      </li> -->
    
      <!-- Settings Link -->
    
    
      <!-- User Profile Dropdown -->
   
    </ul>
    </div>
  </div>
</nav>